<template>
  <modal
    name="cart"
    width="100%"
    height="auto"
    :scrollable="true"
    :adaptive="true"
    transition="fade-down"
    classes=""
    :clickToClose="true"
    @before-close="beforeClose">

    <component :is="cartComponent"></component>

  </modal>
</template>

<script>
import axios from "axios";
import { EventBus } from "../../lib/event-bus.js";
import QtyForm from "./QtyForm.vue";
import RemoveItem from "./RemoveItem.vue";
import DiscountCode from "./DiscountCode.vue";

export default {
  data() {
    return {
      cartHtml: ''
    }
  },

  computed: {
    cartComponent() {
      return {
        template: this.cartHtml,
        components: {
          QtyForm,
          RemoveItem,
          DiscountCode
        }
      }
    }
  },

  created() {
    EventBus.$on('open-cart', (options) => {
      if (options.reload) {
        this.getCart()
      }

      this.$modal.show('cart')
    });
    EventBus.$on('close-cart', () => this.$modal.hide('cart'));

    EventBus.$on('qty-update', () => {
      this.getCart()
    });

    this.getCart()
  },

  methods: {
    getCart() {
      axios.get('/shop/ajax/cart')
      .then((response) => {
        // console.log('Cart Response:', response);
        this.cartHtml = response.data;
      })
      .catch(function (error) {
        console.error('Cart Error:', error);
      });
    },
    beforeClose() {
      window.location.reload();
    }
  }
}
</script>



// WEBPACK FOOTER //
// _js/components/shop/Cart.vue